export default __webpack_public_path__ + "static/media/drink coffee3.a35d8d3c.png";